import { type RecurrenceSettingsState } from '../../../../types'
import { computeRecurrenceEnd } from './computeRecurrenceEnd'
import { computeRecurrencePeriod } from './computeRecurrencePeriod'

export function updateRecurrenceType(
  state: RecurrenceSettingsState,
  recurrencePeriodType: uui.domain.ui.forms.ExtendedRecurrencePeriodType,
): RecurrenceSettingsState {
  return {
    ...state,
    value: {
      recurrencePeriod: computeRecurrencePeriod(state, recurrencePeriodType),
      recurrenceEnd: computeRecurrenceEnd(state, recurrencePeriodType),
    },
  }
}
